import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { OktaAuthGuard } from '@okta/okta-angular'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'services',
    pathMatch: 'full'
  },
  {
    path: 'services',
    children: [
      {
        path: '',
        loadChildren: () => import('./core-modules/service-list/service-list.module').then(m => m.ServiceListModule),
        canActivate: [OktaAuthGuard]
      },
      {
        path: 'create',
        loadChildren: () => import('./core-modules/service-activation/service-activation.module').then(m => m.ServiceActivationModule),
        canActivate: [OktaAuthGuard]
      },
      {
        path: 'content-provider-management',
        loadChildren: () => import('./core-modules/content-provider-management/content-provider-management.module').then(m => m.ContentProviderManagementModule),
        canActivate: [OktaAuthGuard]
      },
      {
        path: 'contact-info',
        loadChildren: () => import('./core-modules/contact-info/contact-info.module').then(m => m.ContactInfoModule),
        canActivate: [OktaAuthGuard]
      }
    ]
  },
  { path: '401', loadComponent: () => import('./core-modules/error/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent) },
  { path: '404', loadComponent: () => import('./core-modules/error/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent), },
  { path: '503', loadComponent: () => import('./core-modules/error/service-unavailable/service-unavailable.component').then((c) => c.ServiceUnavailableComponent), },
  { path: '**', redirectTo: '404', }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
